import script from "./asideTab.vue?vue&type=script&setup=true&lang=js"
export * from "./asideTab.vue?vue&type=script&setup=true&lang=js"

import "./asideTab.vue?vue&type=style&index=0&id=7f718ff2&scoped=true&lang=less"

import exportComponent from "D:\\git\\media-manage-web-scatoms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f718ff2"]])

export default __exports__